<template>
  <div class="index-module_articleWrap_2Zphx">
      <div  class="zhemo">文华财经小课堂 - 用<common-data name="appShortName_37"/>软件做多因子量化投资</div>
        <p class="index-module_textWrap_3ygOc">量化投资和主观投资不是并列的关系，更不是对立的关系。量化投资是主观投资的延续，主观投资是量化投资的一个子集。
        </p>
        <p class="index-module_textWrap_3ygOc">主观投资策略，以及很多研报中提及的交易策略，也可以使用量化投资工具进行验证和优化。通过多年的历史数据验证过的策略，有更大的概率获得稳定的收益。
        </p>
        <p class="index-module_textWrap_3ygOc">本期课程讲述如何利用<common-data name="appShortName_37"/>的量化投资工具、文华因子库复现券商研报中的沪深300指数增强策略，并检验策略有效性。
        </p>
         <div class="info table2">
            <table cellpadding="7" cellspacing="0" style="width: 730px;background: #f7f9fc;text-indent:0">
                <tr class="center">
                    <th valign="top" width="18%">题目</th>
                    <th valign="top">内容</th>
                    <th valign="top" width="9%">讲师</th>
                </tr>
               <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">多因子选股策略</td>
                    <td>多因子选股策略的本质是定价，是综合了市场上各类交易者不同角度的价格判断形成的定价。</td>
                    <td rowspan="7"  style="padding:0 5px;text-align:center;text-indent:0">孙健</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">案例：沪深300指数增强策略</td>
                    <td>用系统因子库复现券商研报中的沪深300指数增强策略。</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">检验策略有效性</td>
                    <td>通过多维度的回测报告，从收益分析、回撤分析、收益归因、行业分布、交易分析、持仓明细等多个角度验证策略优劣。</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">文华因子库</td>
                    <td>涵盖了文华十几年的量化研究成果，长期跟踪机构研究动态，及时共享市场最前沿因子。价值类、成长类、盈利类、行为金融类等众多类别的精选因子，覆盖股票投资的各个领域。</td>
                </tr>
            </table>
        </div>
        <div  class="index-module_textWrap_3ygOc">
                讲师介绍：
        </div>
        <!-- <div>【孙健】&nbsp;文华产品经理</div> -->
            <div  class="index-module_textWrap_3ygOc">
              【孙健】  &nbsp;文华财经大客户业务部产品经理，十年来专注于客户需求整理和产品设计，每年多次在全国范围内举办和参与期货和证券领域的大型授课活动，现主要负责服务机构客户，为专业的投资者提供技术支持，解决实际使用中的问题。
        </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.info,
.SignUp {
    color: #646464;
    line-height: 180%;
    padding: 0 0 3px 2em;
    font-size: 14px;
}
.info table{
    border: 1px solid #d1d7d7;
    border-collapse: collapse;
}

.info_2 {
    color: #646464;
    line-height: 180%;
    padding-bottom: 3px;
}

.info table {
    width: 688px;
}

.info th {
            padding: 5px 0;

    height: 24px;
    line-height: 24px;
    background: #a4bce2;
    color: #ffffff;
    border: 1px solid #d1d7d7;
    font-size: 14px;
    font-weight: normal;
    text-align: center;
}

.info td {
    padding: 0;
     padding: 5px 8px;

    border: 1px solid #d1d7d7;
    vertical-align: middle;
    padding-left: 8px;
}

.info td.time {
    color: #002c6f;
}

.td_w,.td_b{
    line-height: 29px;
    padding: 0 0 0 22px;
    font-size: 14px;
    color: #646567;
}

.td_b{
    background: #eef0fd;
}
.table2 tr td:first-child{
    text-align: left !important;
    padding-left: 10px !important;
}
</style>